import { en } from './en';

export const fr: Record<string, string> = {
  'delivery.title': "Où devons-nous livrer votre commande ?",
  'delivery.beforeSignup': "Vérifiez la disponibilité de la livraison avant de saisir vos coordonnées.",
  'delivery.country': "Pays de livraison",
  'delivery.choose': "Choisissez votre pays de livraison",
  'delivery.availableTo': "Livraison vers :",
  'delivery.blocked': "Certains articles ne peuvent pas être livrés dans le pays sélectionné. Votre panier a été conservé. Choisissez un autre pays de livraison ou retirez les articles indisponibles.",
  'delivery.backToCart': "Retour au panier",
  'delivery.updateAddress': "Modifier l’adresse de livraison",
  'delivery.checkFailed': "Impossible de vérifier la disponibilité de la livraison. Votre panier a été conservé. Veuillez réessayer.",
  'delivery.retry': "Réessayer",
  'delivery.checking': "Vérification de la disponibilité de la livraison…",
  ...en,
  'cart.adding': 'Ajout en cours...',
  'cart.added': 'Ajouté',
  'cart.addSuccess': 'Produit ajouté au panier',
  'cart.addFail': 'Échec de l\'ajout du produit : {error}',
  'title.cart': 'Panier',
  'title.catalog': 'Catalogue',
  'title.checkout': 'Paiement',
  'title.signup': 'S\'inscrire',
  'title.tickets': 'Assistance',
  'title.discounts': 'Votre réduction personnelle',
  'auth.login': 'Connexion',
  'auth.loginModal.remindPassword': 'Mot de passe oublie ?',
  'auth.logout': 'Déconnexion',
  'auth.signup': 'S\'inscrire',
  'auth.myAccount': 'Mon compte',
  'auth.orders': 'Mes commandes',
  'auth.discount': 'Votre réduction personnelle !',
  'discounts.title': 'Votre réduction personnelle',
  'discounts.description': 'Cette réduction est automatiquement appliquée à toutes vos commandes.',
  'auth.bonusAccount': 'Votre compte bonus',
  'auth.referral': 'Programme de parrainage',
  'auth.subscriptions': 'Abonnements',
  'title.subscriptions': 'Abonnements',
  'subs.loading': 'Chargement...',
  'subs.loginRequired': 'Veuillez vous connecter pour gérer vos abonnements.',
  'subs.empty': 'Aucune newsletter disponible.',
  'subs.instruction': 'Sélectionnez les newsletters auxquelles vous souhaitez vous abonner ou vous désabonner',
  'subs.list.1.name': 'Remises produits',
  'subs.list.1.descr': 'Réductions sur les produits qui vous intéressent. Fréquence – mensuelle',
  'subs.list.2.name': 'Remises anniversaire',
  'subs.list.2.descr': 'E-mail d anniversaire avec cadeau. Fréquence – annuelle',
  'subs.list.3.name': 'Rappel de renouvellement',
  'subs.list.3.descr': 'Notification de renouvellement. Fréquence – tous les 2 à 3 mois',
  'subs.list.4.name': 'Actualités boutique',
  'subs.list.4.descr': 'Fréquence – rarement',
  'subs.success': 'Abonnements mis à jour',
  'subs.failed': 'Échec de la mise à jour.',
  'subs.updating': 'Mise à jour...',
  'subs.update': 'Mettre à jour',
  'inline.loginLink': 'connectez-vous',
  'inline.loginRequiredPrefix': 'Veuillez ',
  'inline.loginRequiredSuffix': ' pour consulter cette page.',
  'inline.subscriptionsAuthRedirect':
    'Les abonnements à la newsletter ne sont disponibles que pour les clients connectés. Connectez-vous pour continuer.',
  'subscribe.title': 'Abonnez-vous aux offres',
  'subscribe.subtitle': 'Recevez des réductions exclusives et des rappels de commande',
  'subscribe.cta': 'S abonner',
  'subscribe.emailLabel': 'E-mail',
  'subscribe.emailPlaceholder': 'vous@email.fr',
  'subscribe.phoneLabel': 'Telephone',
  'subscribe.phonePlaceholder': '+33 1 23 45 67 89',
  'subscribe.consentLabel': 'J accepte de recevoir des e-mails promotionnels et des rappels de commande',
  'subscribe.consentRequired': 'Veuillez accepter de recevoir des e-mails',
  'subscribe.invalidEmail': 'Veuillez saisir une adresse e-mail valide',
  'subscribe.success': 'Merci ! Votre abonnement est actif.',
  'auth.tickets': 'Assistance',
  'auth.deleteAccount': 'Supprimer le compte',
  'cartWidget.cart': 'Panier',
  'cartWidget.viewCart': 'VOIR LE PANIER',
  'cartWidget.shoppingCart': 'Panier',
  'cartWidget.items': 'articles',
  'title.checkoutQnr': 'Questionnaire médical',
  'title.checkoutConfirm': 'Confirmation de commande',
  'cartPage.empty': 'Votre panier est vide',
  'cartPage.product': 'Produit',
  'cartPage.qty': 'Qté',
  'cartPage.price': 'Prix',
  'cartPage.lineTotal': 'Total',
  'cartPage.loading': 'Chargement du panier...',
  'cartPage.startShopping': 'Commencer les achats',
  'cartPage.recalculate': 'Recalculer',
  'cartPage.remove': 'Supprimer',
  'cartPage.free': 'Gratuit',
  'cartPage.quickNotes': 'Notes rapides :',
  'cartPage.note1': '1. L assurance livraison garantit un remboursement ou une reexpedition.',
  'cartPage.note2': '2. Le paiement en Bitcoin donne 10 % de reduction.',
  'cartPage.note3': '3. Saisissez un coupon de reduction valide ci-dessous.',
  'cartPage.note4': '4. Certaines reductions s activent apres le choix du paiement.',
  'cartPage.couponPlaceholder': 'Saisissez un coupon ici',
  'cartPage.couponLabel': 'Code coupon',
  'cartPage.couponSubmit': 'Appliquer',
  'cartPage.couponInvalid': 'Le coupon est invalide ou expire.',
  'cartPage.couponSuccess': 'Le coupon a ete ajoute avec succes.',
  'cartPage.couponNotApplied': 'Le coupon n a pas ete applique. Il est invalide, restreint pour le mode de paiement choisi ou ne respecte pas les conditions de la promotion.',
  'cartPage.couponCleared': 'Le coupon a ete supprime.',
  'cartPage.itemRemoved': 'Article supprime du panier.',
  'cartPage.removeFailed': 'Impossible de supprimer l article.',
  'cartPage.updateQtyFailed': 'Impossible de mettre à jour la quantité.',
  'cartPage.qtyDecrease': 'Diminuer la quantité',
  'cartPage.qtyIncrease': 'Augmenter la quantité',
  'cartPage.maxPillsHint': 'Max. {pills} comprimés ({packs} boîtes)',
  'cartPage.deliveryMethod': 'Mode de livraison :',
  'cartPage.standard': 'Standard',
  'cartPage.subtotal': 'Sous-total :',
  'cartPage.personalDiscount': 'Reduction personnelle :',
  'cartPage.bonusDiscount': 'Reduction bonus :',
  'cartPage.discountCoupon': 'Coupon de reduction :',
  'cartPage.clearCoupon': 'Supprimer le coupon',
  'cartPage.shippingCost': 'Frais de livraison :',
  'cartPage.discounted': 'reduit',
  'cartPage.freeShipping': 'livraison gratuite',
  'cartPage.shippingInsurance': 'Assurance livraison :',
  'cartPage.backToShopping': 'Retour aux achats',
  'shippingMethod.airmail_service': 'Service postal aerien',
  'cartPage.total': 'Total :',
  'cartPage.checkout': 'Paiement',
  'stepper.cart': 'Panier',
  'stepper.payment': 'Paiement',
  'stepper.medical': 'Médical',
  'stepper.confirm': 'Confirmer',
  'miniCart.subtotal': 'Sous-total :',
  'miniCart.personalDiscount': 'Reduction personnelle :',
  'miniCart.bonusDiscount': 'Reduction bonus :',
  'miniCart.discountCoupon': 'Coupon de reduction :',
  'miniCart.shippingCost': 'Frais de livraison :',
  'miniCart.freeShipping': 'livraison gratuite',
  'miniCart.shippingInsurance': 'Assurance livraison :',
  'miniCart.total': 'Total :',
  'miniCart.editCart': 'Modifier le panier',
  'checkout.continue': 'Continuer',
  'confirm.title': 'Confirmation de commande',
  'confirm.placeOrder': 'Passer la commande',
  'qnr.title': 'Questionnaire médical',
  'confirm.retentionConsent': "J'accepte de recevoir des e-mails promotionnels et des rappels concernant mes commandes",
  'profile.updateProfile': 'Mettre à jour le profil',
  'telegram.title': 'Notifications Telegram',
  'telegram.hint': 'Connectez Telegram pour recevoir les mises à jour de commande, les alertes de suivi et le chat support sur votre téléphone.',
  'telegram.orderFcTitle': 'Confirmez votre commande via Telegram',
  'telegram.orderFcIntro': 'Cette commande nécessite une confirmation rapide de vos informations avant l’envoi des instructions de paiement.',
  'telegram.orderFcFastest': 'Option la plus rapide : connectez Telegram ci-dessous. Après la commande, le bot enverra une demande de confirmation.',
  'telegram.orderFcAlternatively': 'Autre option : confirmer par téléphone ou',
  'telegram.liveChat': 'chat en direct',
  'telegram.orderFcReady': 'Nous pouvons envoyer la demande de confirmation sur votre Telegram. Vérifiez le chat du bot.',
  'telegram.orderInfoTitle': 'Recevoir les mises à jour sur Telegram',
  'telegram.orderInfoIntro': 'Connectez notre bot support pour :',
  'telegram.orderInfoItem1': 'Statut de commande et mises à jour d’expédition',
  'telegram.orderInfoItem2': 'Scans de suivi et alertes de livraison',
  'telegram.orderInfoItem3': 'Rappels de paiement si nécessaire',
  'telegram.orderInfoItem4': 'Chat direct avec le support depuis votre téléphone',
  'telegram.statusLoading': 'Vérification de la connexion Telegram…',
  'telegram.unavailable': 'La connexion Telegram n’est pas disponible pour le moment.',
  'telegram.connected': 'Telegram connecté',
  'telegram.connectedAt': 'Connecté',
  'telegram.boundFrom': 'Connecté depuis',
  'telegram.connect': 'Connecter Telegram',
  'telegram.connecting': 'Connexion…',
  'telegram.linkReady': 'Ouvrez Telegram et appuyez sur Start pour terminer la liaison de votre compte.',
  'telegram.openTelegram': 'Ouvrir Telegram',
  'telegram.copyLink': 'Copier le lien',
  'telegram.copied': 'Copié',
  'telegram.expiresMinutes': 'Le lien expire dans environ {minutes} minutes.',
  'telegram.notificationsTitle': 'Préférences de notification',
  'telegram.notificationsHint': 'La confirmation de commande et le chat support fonctionnent toujours. Choisissez les alertes optionnelles ci-dessous.',
  'telegram.notificationsSaving': 'Enregistrement…',
  'telegram.notificationsSaveError': 'Impossible d’enregistrer les paramètres de notification.',
  'telegram.disconnect': 'Déconnecter Telegram',
  'telegram.disconnectConfirm': 'Déconnecter Telegram de votre compte ? Vous pourrez le reconnecter depuis cette page.',
  'telegram.disconnectYes': 'Oui, déconnecter',
  'telegram.disconnectCancel': 'Annuler',
  'telegram.coupon.checkoutTitle': 'Connectez Telegram et économisez 20 %',
  'telegram.coupon.checkoutBody': 'Connectez-vous maintenant et nous appliquerons 20 % à cette commande.',
  'telegram.coupon.checkoutAction': 'Connecter Telegram et appliquer 20 %',
  'telegram.coupon.applied': 'Telegram connecté — votre réduction de 20 % a été appliquée.',
  'telegram.coupon.replaceConfirm': 'Remplacer le coupon actuel et appliquer 20 %',
  'telegram.coupon.active': 'Coupon Telegram de {percent} % disponible.',
  'telegram.coupon.redeemed': 'Coupon Telegram utilisé.',
  'telegram.coupon.expired': 'Le coupon Telegram a expiré.',
  'telegram.disconnectError': 'Impossible de déconnecter Telegram.',
  'telegram.pref.order_status.label': 'Mises à jour du statut de commande',
  'telegram.pref.order_status.description': 'Traitement, annulation, refus et autres changements de statut.',
  'telegram.pref.shipped.label': 'Expédition et numéros de suivi',
  'telegram.pref.shipped.description': 'Lorsque votre commande est expédiée ou réexpédiée avec un numéro de suivi.',
  'telegram.pref.tracking_updates.label': 'Scans de suivi de livraison',
  'telegram.pref.tracking_updates.description': 'Mises à jour du transporteur : en transit, en livraison ou livré.',
  'telegram.pref.payment.label': 'Rappels de paiement',
  'telegram.pref.payment.description': 'Instructions de paiement et avis de paiement insuffisant.',
  'telegram.pref.promotions.label': 'Promotions et offres',
  'telegram.pref.promotions.description': 'Remises optionnelles et offres spéciales.',
  'signup.createAccount': 'Créer un compte',
  'login.title': 'Connexion',
  'login.loginLabel': 'Identifiant',
  'login.loginPlaceholder': 'E-mail ou nom d\'utilisateur',
  'login.passwordLabel': 'Mot de passe',
  'login.loginRequired': 'L\'identifiant est obligatoire',
  'login.passwordRequired': 'Le mot de passe est obligatoire',
  'login.invalidCredentials': 'E-mail ou mot de passe invalide.',
  'login.noAccount': 'Pas de compte ?',
  'login.signupLink': 'Inscription',
  'login.submit': 'Se connecter',
  'signup.personalInfo': 'Informations personnelles',
  'signup.title': 'Civilite',
  'signup.mr': 'M.',
  'signup.mrs': 'Mme',
  'signup.ms': 'Mlle',
  'signup.firstName': 'Prenom',
  'signup.lastName': 'Nom',
  'signup.contactInfo': 'Informations de contact',
  'signup.email': 'E-mail',
  'signup.phone': 'Telephone',
  'signup.billingAddress': 'Adresse de facturation',
  'signup.address': 'Adresse',
  'signup.zipcode': 'Code postal',
  'signup.city': 'Ville',
  'signup.country': 'Pays',
  'signup.state': 'Region',
  'signup.selectCountry': 'Selectionner un pays',
  'signup.stateProvince': 'Region / Province',
  'signup.selectState': 'Selectionner une region',
  'signup.shippingAddress': 'Adresse de livraison',
  'signup.sameAsBilling': 'Identique a l\'adresse de facturation',
  'signup.privacyInfo': 'Informations de confidentialite',
  'signup.password': 'Mot de passe',
  'signup.passwordHint': '5 caracteres minimum. Doit etre different du nom d\'utilisateur.',
  'signup.confirmPassword': 'Confirmer le mot de passe',
  'signup.agreeTermsTemplate': 'J\'accepte les {terms} de l\'entreprise.',
  'signup.agreeTermsLink': 'Conditions generales',
  'signup.firstNameRequired': 'Le prenom est obligatoire',
  'signup.lastNameRequired': 'Le nom est obligatoire',
  'signup.emailRequired': 'L\'e-mail est obligatoire',
  'signup.emailInvalid': 'Format d\'e-mail invalide',
  'signup.phoneRequired': 'Le telephone est obligatoire',
  'signup.addressRequired': 'L\'adresse est obligatoire',
  'signup.zipcodeRequired': 'Le code postal est obligatoire',
  'signup.cityRequired': 'La ville est obligatoire',
  'signup.countryRequired': 'Le pays est obligatoire',
  'signup.passwordRequired': 'Le mot de passe est obligatoire',
  'signup.passwordMinLength': 'Le mot de passe doit contenir au moins 5 caracteres',
  'signup.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'signup.termsRequired': 'Vous devez accepter les conditions generales',
  'signup.failed': 'Echec de l\'inscription',
  'signup.creating': 'Creation du compte...',
  'forgotPassword.emailLabel': 'E-mail',
  'forgotPassword.emailPlaceholder': 'vous@exemple.fr',
  'forgotPassword.submit': 'Envoyer le code',
  'forgotPassword.success': 'Nous avons envoye un code de 10 caracteres a votre e-mail.',
  'forgotPassword.successHint': 'Saisissez le code sur la page suivante pour definir un nouveau mot de passe.',
  'forgotPassword.goToSetPassword': 'Saisir le code et definir le mot de passe',
  'forgotPassword.backToLogin': 'Retour a la connexion',
  'forgotPassword.invalidEmail': 'Saisissez une adresse e-mail valide',
  'resetPassword.emailLabel': 'E-mail',
  'resetPassword.resetCodeLabel': 'Code recu par e-mail',
  'resetPassword.resetCodePlaceholder': '10 caracteres',
  'resetPassword.resetCodeFormat': 'Le code doit contenir exactement 10 lettres ou chiffres',
  'resetPassword.newPasswordLabel': 'Nouveau mot de passe',
  'resetPassword.confirmLabel': 'Confirmer le mot de passe',
  'resetPassword.passwordPlaceholder': '••••••••',
  'resetPassword.passwordMin': 'Le mot de passe doit contenir au moins 5 caracteres',
  'resetPassword.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'resetPassword.submit': 'Enregistrer',
  'resetPassword.success': 'Mot de passe mis a jour. Vous pouvez maintenant vous connecter.',
  'resetPassword.redirectHint': 'Redirection...',
  'orders.title': 'Mes commandes',
  'tickets.newMessage': 'Message',
  'tickets.newUpload': 'Telecharger des fichiers (PDF, JPG, PNG, TXT)',
  'contact.formTitle': 'Envoyez-nous un message',
  'contact.loginRequired': 'Veuillez vous connecter pour envoyer un ticket de support.',
  'testimonials.customer': 'Client',
  'testimonials.loading': 'Chargement des temoignages...',
  'testimonials.empty': 'Aucun temoignage pour le moment.',
  'testimonials.loadError': 'Impossible de charger les temoignages. Veuillez reessayer plus tard.',
  'testimonials.formTitle': 'Laisser un temoignage',
  'testimonials.namePlaceholder': 'Votre nom',
  'testimonials.messagePlaceholder': 'Votre avis',
  'testimonials.submitting': 'Envoi...',
  'testimonials.submit': 'Envoyer l avis',
  'testimonials.submitError': 'Impossible d envoyer le temoignage.',
  'testimonials.loginRequired': 'Veuillez vous connecter pour laisser un temoignage.',
  'testimonials.validationName': 'Le nom doit contenir au moins 2 caracteres.',
  'testimonials.validationMessage': 'L avis doit contenir au moins 6 caracteres.',
  'testimonials.success': 'Merci pour votre avis ! Il apparaitra apres moderation.',
  'contact.requestFrom': 'La demande sera envoyee depuis',
  'contact.unknownUser': 'Utilisateur authentifie',
  'contact.subject': 'Sujet',
  'contact.subjectPlaceholder': 'Comment pouvons-nous vous aider ?',
  'contact.message': 'Message',
  'contact.messagePlaceholder': 'Decrivez votre probleme...',
  'contact.send': 'Envoyer le message',
  'contact.ticketsLoginRequired': 'Connectez-vous pour consulter et soumettre des tickets de support.',
  'chat.online': 'En ligne',
  'chat.offline': 'Hors ligne',
  'chat.coming_soon': 'Le chat en direct est en cours de configuration. Utilisez l\'e-mail ou le telephone pour le moment.',
  'chat.offline_message': 'Nos operateurs sont actuellement hors ligne.',
  'chat.leave_message': 'Laissez un message et nous vous repondrons.',
  'chat.leave_ticket': 'Laisser un ticket',
  'nav.login': 'Se connecter',
  'nav.signup': 'Creer un compte',
  'miniCart.deliveryMethod': 'Mode de livraison',
  'month.1': 'Janvier', 'month.2': 'Fevrier', 'month.3': 'Mars',
  'month.4': 'Avril', 'month.5': 'Mai', 'month.6': 'Juin',
  'month.7': 'Juillet', 'month.8': 'Aout', 'month.9': 'Septembre',
  'month.10': 'Octobre', 'month.11': 'Novembre', 'month.12': 'Decembre',
  'checkout.accountHint': 'Numero de compte - Vient generalement avant le numero de cheque ; l\'emplacement varie.',
  'checkout.accountNumber': 'Numero de compte',
  'checkout.authLogin': 'Se connecter',
  'checkout.authPrompt': 'Veuillez vous connecter ou vous inscrire pour continuer le paiement.',
  'checkout.authSignup': 'S\'inscrire',
  'checkout.backToConfirm': 'Retour a la confirmation de commande',
  'checkout.backToShop': 'Retour a la boutique',
  'checkout.bankName': 'Nom de la banque',
  'checkout.btcStep1': "Finalisez votre commande pour ouvrir la page de paiement.",
  'checkout.btcStep2': "Envoyez le montant exact en BTC à l’adresse indiquée, en utilisant le réseau spécifié.",
  'checkout.btcStep3': "Payez avant l’expiration des coordonnées de paiement.",
  'checkout.btcOrderNote': "Utilisez ces coordonnées de paiement uniquement pour cette commande. Aucune confirmation téléphonique n’est nécessaire.",
  'checkout.btcHelp': "Comment acheter des bitcoins",
  "checkout.cryptoTitle": "Payer en cryptomonnaie",
  "checkout.cryptoStep1": "Cliquez sur Continuer.",
  "checkout.cryptoStep2": "Choisissez votre monnaie et le réseau sur la page suivante.",
  "checkout.cryptoStep3": "Suivez les instructions pour finaliser votre paiement.",
  "checkout.cryptoCoinsLabel": "Monnaies disponibles",
  "checkout.cryptoCoins": "Ethereum · Litecoin · Bitcoin Cash · Dogecoin · Monero · Tron · XRP · Cardano · TON · BNB",
  "checkout.cryptoNetworks": "Choisissez Ethereum (ERC-20), Tron (TRC-20) ou BNB Smart Chain (BEP-20).",
  "checkout.cryptoBitcoinTitle": "Vous souhaitez payer en Bitcoin (BTC) ?",
  "checkout.cryptoBitcoinNote": "Sélectionnez le mode de paiement Bitcoin distinct lors du paiement.",
  'checkout.btcTitle': "Payer en Bitcoin",
  'checkout.cartEmpty': 'Votre panier est vide.',
  'checkout.ccNumber': 'Numero de carte de credit (sans espaces ni tirets)',
  'checkout.ccType': 'Type de carte de credit',
  'checkout.checkNumber': 'Numero de cheque',
  'checkout.cvv': 'CVV2',
  'checkout.error': 'Une erreur s\'est produite',
  'checkout.expDate': 'Date d\'expiration',
  'checkout.loading': 'Chargement de la caisse...',
  'checkout.noPayments': 'Malheureusement, aucun paiement n\'est disponible pour le paiement. Veuillez contacter le service commercial ou d\'assistance.',
  'checkout.paymentFailed': 'Echec de la definition du mode de paiement',
  'checkout.processing': 'Traitement...',
  'checkout.routingHint': 'Numero d\'acheminement (code ABA) - Generalement 9 chiffres sur votre cheque.',
  'checkout.routingNumber': 'Numero d\'acheminement (code ABA)',
  'checkout.selectPayment': 'Selectionnez un mode de paiement',
  'contact.email': 'E-mail',
  'contact.hours': 'Heures de travail',
  'contact.previewHours': 'Lun-Ven 9:00-18:00',
  'contact.support247': 'Assistance 24/7',
  'contact.live_chat': 'Chat en direct',
  'contact.open_ticket': 'Ouvrir un ticket',
  'contact.phone': 'Telephone',
  'contact.start_chat': 'Demarrer le chat',
  'contact.tickets_desc': 'Vous avez une question ? Ouvrez un ticket d\'assistance et nous vous repondrons.',
  'contact.title': 'Contactez-nous',
  'contact.unavailable': 'Les coordonnees ne sont pas disponibles.',
  'deleteAccount.attention': 'Attention!',
  'deleteAccount.failed': 'La demande a echoue. Veuillez reessayer.',
  'deleteAccount.password': 'Mot de passe',
  'deleteAccount.passwordRequired': 'Un mot de passe est requis.',
  'deleteAccount.reason': 'Raison',
  'deleteAccount.reasonHint': 'Veuillez partager la raison de votre depart. Vos commentaires nous aident a nous ameliorer.',
  'deleteAccount.reasonRequired': 'La raison est requise.',
  'deleteAccount.rule1': 'Vous ne devriez avoir aucune retrofacturation dans votre historique.',
  'deleteAccount.rule2': 'Au moins 21 jours doivent s\'ecouler apres votre derniere commande reussie.',
  'deleteAccount.rules': 'Regles de suppression de compte :',
  'deleteAccount.safetyInfo': 'Votre vie privee nous tient a coeur. Vous pouvez supprimer definitivement votre compte et l\'historique associe a tout moment.',
  'deleteAccount.submit': 'Soumettre',
  'deleteAccount.success': 'Compte supprime avec succes.',
  'deleteAccount.thanks': 'Merci d\'avoir choisi notre service.',
  'deleteAccount.warning': 'Si une retrofacturation est recue ulterieurement pour une commande, votre compte peut etre restaure pour traiter ce cas. Pour toute question, contactez le support 24h/24 et 7j/7.',
  'profile.address': 'Adresse',
  'profile.addressRequired': 'L\'adresse est requise',
  'profile.billingAddress': 'Adresse de facturation',
  'profile.changePassword': 'Changer le mot de passe',
  'profile.city': 'Ville',
  'profile.cityRequired': 'La ville est obligatoire',
  'profile.confirmPassword': 'Confirmez le mot de passe',
  'profile.country': 'Pays',
  'profile.countryRequired': 'Le pays est requis',
  'profile.email': 'E-mail',
  'profile.emailInvalid': 'Format d\'e-mail invalide',
  'profile.emailRequired': 'L\'e-mail est requis',
  'profile.firstName': 'Prenom',
  'profile.firstNameRequired': 'Le prenom est obligatoire',
  'profile.lastName': 'Nom de famille',
  'profile.lastNameRequired': 'Le nom de famille est obligatoire',
  'profile.loadFailed': 'Echec du chargement des donnees de profil',
  'profile.loading': 'Chargement du profil...',
  'profile.mr': 'M.',
  'profile.mrs': 'Mme.',
  'profile.ms': 'Mlle',
  'profile.newPassword': 'Nouveau mot de passe',
  'profile.passwordHint': 'Laissez vide si vous ne souhaitez pas modifier votre mot de passe.',
  'profile.passwordMinLength': 'Le mot de passe doit contenir au moins 5 caracteres',
  'profile.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'profile.personalInfo': 'Informations personnelles',
  'profile.phone': 'Telephone',
  'profile.phoneRequired': 'Le telephone est requis',
  'profile.sameAsBilling': 'Identique a l\'adresse de facturation',
  'profile.saving': 'Enregistrement...',
  'profile.selectCountry': 'Selectionnez un pays',
  'profile.selectState': 'Selectionnez l\'etat',
  'profile.shippingAddress': 'Adresse de livraison',
  'profile.state': 'Etat',
  'profile.stateProvince': 'Etat/Province',
  'profile.title': 'Titre',
  'profile.updateFailed': 'La mise a jour a echoue',
  'profile.updateSuccess': 'Profil mis a jour avec succes',
  'profile.zipcode': 'Code postal',
  'profile.zipcodeRequired': 'Le code postal est requis',
  'select.noResults': 'Aucun resultat trouve',
  'select.placeholder': 'Selectionner...',
  'select.search': 'Recherche...',
  'tickets.activationFailed': 'Echec de l\'envoi de l\'e-mail d\'activation',
  'tickets.activationSuccess': 'E-mail d\'activation envoye avec succes',
  'tickets.authInstructions': 'Si vous souhaitez l\'activer, veuillez cliquer sur le bouton ci-dessous et nous vous enverrons les instructions par e-mail.',
  'tickets.authNotActivated': 'Le systeme de tickets n\'a pas encore ete active pour votre compte.',
  'tickets.backToTickets': 'Retour aux tickets',
  'tickets.createSuccess': 'Ticket cree avec succes',
  'tickets.date': 'Date',
  'tickets.dateLabel': 'Date:',
  'tickets.detailLoading': 'Chargement du ticket...',
  'tickets.empty': 'Aucun ticket trouve pour le moment. Utilisez \"Ouvrir un nouveau ticket\" pour poser une question',
  'tickets.fileLimit': 'Selectionnez jusqu\'a 3 fichiers.',
  'tickets.lastReply': 'Derniere reponse',
  'tickets.loading': 'Chargement des tickets...',
  'tickets.loadingMore': 'Chargement supplementaire...',
  'tickets.message': 'Message',
  'tickets.newSubject': 'Sujet',
  'tickets.newTicketTitle': 'Ouvrir un nouveau ticket',
  'tickets.noMessages': 'Aucun message trouve.',
  'tickets.messagesHeading': 'Messages',
  'tickets.messageFromSupport': 'Assistance',
  'tickets.messageFromYou': 'Vous',
  'tickets.replyHeading': 'Répondre',
  'tickets.attachFiles': 'Joindre des fichiers',
  'tickets.filesCount': '{count} fichier(s)',
  'tickets.notActivated': 'Systeme de tickets non active pour votre compte.',
  'tickets.openNew': 'Ouvrir un nouveau ticket',
  'tickets.refresh': 'Rafraichir',
  'tickets.resolve': 'Resoudre le ticket',
  'tickets.resolveConfirm': 'Etes-vous sur de vouloir resoudre ce ticket ?',
  'tickets.sendActivation': 'Envoyer un e-mail d\'activation',
  'tickets.sendReply': 'Envoyer la reponse',
  'tickets.status': 'Statut',
  'tickets.statusAwaitingAgent': 'Agent en attente',
  'tickets.statusAwaitingUser': 'En attente d\'un utilisateur',
  'tickets.statusLabel': 'Statut:',
  'tickets.statusPending': 'En attente',
  'tickets.statusResolved': 'Resolu',
  'tickets.subject': 'Sujet',
  'tickets.submitTicket': 'Envoyer le ticket',
  'tickets.title': 'Tickets de support',
  'tickets.uploadFiles': 'Telechargez des fichiers (PDF, JPG, PNG, TXT)',
  'close': 'Fermer',
  'loading': 'Chargement...',
  'yes': 'Oui',
  'no': 'Non',
  'tickets.unavailable': 'Les tickets de support sont temporairement indisponibles. Veuillez réessayer plus tard ou contacter le support par e-mail en cas d\'urgence.',
  'api.genericError': 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
  'api.networkError': 'Service temporairement indisponible. Vérifiez votre connexion.',
  'api.error.10503': 'Service indisponible',
  'api.error.40001': 'L\'authentification du client a échoué',
  'api.error.40004': 'La validation des données client a échoué',
  'api.error.40008': 'Ce login existe déjà',
  'api.error.40009': 'Cet e-mail existe déjà',
  'api.error.40021': 'Le compte client existe déjà',
  'api.error.40022': 'Client introuvable',
  'api.error.400014': 'Le coupon est invalide',
  'api.error.50001': 'La vérification anti-fraude a échoué',
  'api.error.50002': 'Le compte a des commandes en cours et ne peut pas être supprimé.',
  'api.error.60001': 'Ce produit est actuellement indisponible.',
  'geo.soft_notice': 'This product has delivery region limits. Final availability is confirmed after sign-in using your shipping address.',
  'api.error.60101': 'Vous pouvez ajouter jusqu\'à {limit} produits différents par commande.',
  'api.error.60102': 'La quantité maximale pour ce produit est {limit}.',
  'api.error.60103': 'Le nombre maximal de packs pour ce produit est {limit}.',
  'unsubscribe.processing': 'Traitement en cours…',
  'unsubscribe.success': 'Vous avez été désinscrit des e-mails marketing de {shop_name}.',
  'unsubscribe.shop': 'Boutique',
  'unsubscribe.invalidLink': 'Lien invalide ou expiré.',
  'unsubscribe.error': 'Une erreur s\'est produite.',

  'title.orderReturn': 'Statut du paiement',
  'orderReturn.successTitle': 'Merci !',
  'orderReturn.successLead': 'Votre paiement a bien été reçu.',
  'orderReturn.successHint': 'Un e-mail de confirmation vous a été envoyé. Les informations d\'expédition suivront.',
  'orderReturn.cancelTitle': 'Paiement annulé',
  'orderReturn.cancelLead': 'Aucun paiement n\'a été effectué pour cette commande.',
  'orderReturn.cancelHint': 'Après le paiement, le panier est vidé. Utilisez les détails de commande ou « Réessayer » ci-dessous.',
  'orderReturn.failureTitle': 'Paiement échoué',
  'orderReturn.failureLead': 'Nous n\'avons pas pu finaliser le paiement de cette commande.',
  'orderReturn.failureHint': 'Le panier a été vidé lors de la commande. Réessayez, consultez les détails ou contactez le support.',
  'orderReturn.btnDetails': 'Voir les détails de la commande',
  'orderReturn.btnSignIn': 'Connectez-vous pour voir les détails',
  'orderReturn.btnContinueShopping': 'Continuer vos achats',
  'orderReturn.btnContactSupport': 'Contacter le support',
  'orderReturn.btnTryAgain': 'Réessayer',
  'confirm.loadFailed': 'Impossible de charger les détails de la commande',
  'confirm.shippingAddress': 'Adresse de livraison',
  'confirm.edit': 'Modifier',
  'confirm.paymentMethod': 'Mode de paiement',
  'confirm.notSelected': 'Non sélectionné',
  'confirm.shippingNote': '*La livraison US2US prend généralement 3 jours ouvrables après l expédition (jusqu à 5 jours ouvrables).',
  'confirm.overseasShippingNote': '*La livraison overseas prend généralement 14-28 jours ouvrables pour les produits UE et indiens.',
  'confirm.manufacturerNote': '*Nous avons plusieurs fabricants pour ce produit. Si le fabricant que vous avez commandé est actuellement en rupture de stock, nous vous contacterons et proposerons une alternative.',
  'confirm.agreePolicy': 'Je déclare accepter la politique de remboursement et la politique de chargeback',
  'confirm.back': 'Retour',
  'confirm.placing': 'Commande en cours...',
  'confirm.previewModeNotice': 'Mode aperçu - les commandes réelles sont désactivées.',
  'confirm.success': 'Commande passée avec succès !',
  'confirm.invalidResponse': 'Réponse de commande invalide',
  'confirm.failed': 'Impossible de passer la commande',
  'qnr.loading': 'Chargement du questionnaire...',
  'qnr.loadFailed': 'Impossible de charger le questionnaire',
  'qnr.retry': 'Réessayer',
  'qnr.intro': 'Veuillez remplir ce formulaire pour demander l ordonnance du médicament commandé. Ce sont les mêmes informations que l on vous demanderait dans une clinique ou chez un médecin.',
  'qnr.general': 'Informations générales',
  'qnr.dob': 'Date de naissance du patient',
  'qnr.day': 'Jour',
  'qnr.month': 'Mois',
  'qnr.year': 'Année',
  'qnr.dobRequired': 'La date de naissance est obligatoire',
  'qnr.gender': 'Sexe',
  'qnr.selectPlaceholder': 'Sélectionner...',
  'qnr.genderRequired': 'Le sexe est obligatoire',
  'qnr.height': 'Taille du patient',
  'qnr.heightRequired': 'La taille est obligatoire',
  'qnr.weight': 'Poids du patient',
  'qnr.weightRequired': 'Le poids est obligatoire',
  'qnr.medicalHistory': 'Antécédents médicaux',
  'qnr.disorderQuestion': 'Quel est le trouble ou la plainte pour lequel vous demandez ce médicament ?',
  'qnr.conditionRequired': 'La condition médicale est obligatoire',
  'qnr.otherDisease': 'Avez-vous une autre maladie, un trouble ou un autre problème médical ?',
  'qnr.yesNo': 'Veuillez répondre oui ou non',
  'qnr.specifyOther': 'Si oui, veuillez préciser',
  'qnr.specifyRequired': 'Veuillez préciser les autres problèmes médicaux',
  'qnr.confirmations': 'Confirmations',
  'qnr.declaration': 'Je déclare que les informations fournies sont complètes et sans réserve...',
  'qnr.declarationRequired': 'La déclaration est obligatoire',
  'qnr.responsibility': 'Déclaration de responsabilité du client',
  'qnr.responsibilityRequired': 'La déclaration de responsabilité est obligatoire',
  'qnr.consent': 'Je déclare accepter l accord de consentement éclairé',
  'qnr.consentRequired': 'L accord de consentement est obligatoire',
  'qnr.yes': 'Oui',
  'qnr.no': 'Non',
  'qnr.back': 'Retour',
  'qnr.saving': 'Enregistrement...',
  'qnr.continue': 'Continuer',
  'qnr.saved': 'Questionnaire médical enregistré',
  'qnr.saveFailed': 'Impossible d enregistrer le questionnaire',
  'validate.ccEmpty': 'Le numéro de carte ne peut pas être vide',
  'validate.ccInvalid': 'Le numéro de carte est invalide',
  'validate.ccAmex': 'Le numéro de carte Amex doit être valide',
  'validate.ccMaster': 'Le numéro MasterCard doit être valide',
  'validate.ccVisa': 'Le numéro Visa doit être valide',
  'validate.ccTypeEmpty': 'Le type de carte ne peut pas être vide',
  'validate.cvvDigits': 'Le CVV2 doit contenir 3 à 4 chiffres',
  'validate.cvvEmpty': 'Le CVV2 ne peut pas être vide',
  'validate.bankEmpty': 'Le nom de la banque ne peut pas être vide',
  'validate.bankLength': 'Le nom de la banque doit contenir entre 1 et 32 caractères',
  'validate.chequeEmpty': 'Le numéro de chèque ne peut pas être vide',
  'validate.chequeDigits': 'Le numéro de chèque ne doit contenir que des chiffres',
  'validate.chequeLength': 'Le numéro de chèque doit contenir entre 1 et 16 caractères',
  'validate.routingEmpty': 'Le numéro d acheminement ne peut pas être vide',
  'validate.routingDigits': 'Le numéro d acheminement ne doit contenir que des chiffres',
  'validate.routingLength': 'Le numéro d acheminement doit contenir entre 1 et 16 caractères',
  'validate.accountEmpty': 'Le numéro de compte ne peut pas être vide',
  'validate.accountDigits': 'Le numéro de compte ne doit contenir que des chiffres',
  'validate.accountLength': 'Le numéro de compte doit contenir entre 1 et 16 caractères',
  'paymentMethod.credit_card_amex': 'Carte de crédit (Amex)',
  'paymentMethod.credit_card': 'Carte de crédit',
  'paymentMethod.echeque': 'Chèque électronique',
  'paymentMethod.bitcoin': 'Bitcoin',
  'paymentCard.amex': 'Amex',
  'paymentCard.mc': 'MasterCard',
  'paymentCard.visa': 'Visa',
  'orderSuccess.placedSuccess': 'Votre commande a été passée avec succès.',
  'orderSuccess.thanks': 'Merci ! Votre commande a été passée.',
  'orderSuccess.orderId': 'ID de commande :',
  'orderSuccess.description': 'Vous recevrez une confirmation de commande par e-mail. Nous traiterons votre commande dès que possible.',
  'orderSuccess.orderDetails': 'Détails de la commande',
  'orderSuccess.viewOrders': 'Voir mes commandes',
  'orderSuccess.close': 'Retour à la boutique',
  'pagination.label': 'Pagination',
  'pagination.first': 'Première',
  'pagination.previous': 'Précédent',
  'pagination.next': 'Suivant',
  'pagination.last': 'Dernière',

  // ── OrdersView (list/filter) ──
  'orders.loading': 'Chargement des commandes...',
  'orders.loadFailed': 'Impossible de charger les commandes',
  'orders.empty': 'Aucune commande pour le moment.',
  'orders.filter': 'Filtre :',
  'orders.allTime': 'Toute la période',
  'orders.thisMonth': 'Ce mois-ci',
  'orders.thisWeek': 'Cette semaine',
  'orders.today': "Aujourd'hui",

  // ── BonusAccountPage ──
  'referralProgram.headline': 'Invitez un ami : -{friend} % pour lui, -{reward} % pour vous.',
  'referralProgram.intro': 'Partagez votre lien personnel. Après la réception de sa première commande, un coupon distinct de {reward} % apparaîtra ici.',
  'referralProgram.how': 'Votre ami reçoit {friend} % sur sa première commande. Vous recevez après son expédition un coupon de {reward} % valable {months} mois.',
  'referralProgram.rulesTitle': 'Règles des coupons',
  'referralProgram.ruleSeparate': 'Vous recevez un coupon distinct pour chaque nouveau client parrainé.',
  'referralProgram.ruleOnePerOrder': 'Un seul coupon peut être appliqué par commande.',
  'referralProgram.ruleNoLimit': 'La remise de {reward} % ne comporte aucun plafond.',
  'referralProgram.couponsTitle': 'Vos coupons de parrainage',
  'referralProgram.noCoupons': 'Vous n’avez pas encore de coupon de parrainage.',
  'referralProgram.apply': 'Appliquer au panier',
  'referralProgram.applying': 'Application…',
  'referralProgram.expires': 'Expire le',
  'referralProgram.status.active': 'Actif',
  'referralProgram.status.redeemed': 'Utilisé',
  'referralProgram.status.expired': 'Expiré',
  'referralProgram.status.revoked': 'Indisponible',
  'referralShare.button': 'Partager',
  'referralShare.signIn': 'Connectez-vous ou créez un compte pour partager votre lien de parrainage personnel.',
  'referralShare.signInButton': 'Se connecter pour partager',
  'referralShare.copied': 'Lien de parrainage copié.',
  'referralShare.failed': 'Impossible de partager ou de copier votre lien de parrainage.',
  'referralShare.ready': 'Votre lien est prêt. Touchez Partager pour l’envoyer.',
  'referralCoupon.loginRequired': 'Connectez-vous pour appliquer votre coupon de réduction.',
  'referralCoupon.applied': 'Votre coupon de réduction de {reward} % a été appliqué.',
  'referralCoupon.appliedGeneric': 'Votre coupon de réduction a été appliqué.',
  'referralCoupon.applyFailed': 'Impossible d’appliquer ce coupon. Réessayez depuis votre compte.',
  'bonus.headline': 'Gagnez des bonus à vie avec notre programme de parrainage',
  'bonus.intro': 'Invitez vos amis et gagnez des bonus sur leurs achats. Vous pouvez utiliser votre solde bonus pour couvrir jusqu\'à 50 % de votre prochaine commande.',
  'bonus.howTitle': 'Comment ça marche ?',
  'bonus.howDesc': 'Partagez votre lien ou code de parrainage personnel. Lorsqu\'un nouveau client commande avec celui-ci, vous recevez 15 % de la valeur expédiée en crédit bonus.',
  'bonus.subsequent': 'Pour chacune de leurs futures commandes expédiées, vous recevez 5 % supplémentaires.',
  'bonus.friendBenefits': 'Quels sont les avantages pour votre ami ?',
  'bonus.friendDiscount': 'Votre ami bénéficie de 20 % de réduction sur sa première commande en utilisant votre lien ou code.',
  'bonus.whyGreat': 'Pourquoi c\'est avantageux pour vous :',
  'bonus.benefit1': 'Utilisez les bonus pour couvrir jusqu\'à 50 % du total de votre commande.',
  'bonus.benefit2': 'Soyez notifié à chaque crédit de votre solde bonus.',
  'bonus.benefit3': 'Gagnez aussi avec les sous-parrainages : 10 % des bonus que votre filleul direct reçoit.',
  'bonus.startSharing': 'Partagez votre lien de parrainage et commencez à gagner dès aujourd\'hui.',
  'bonus.refLinkLabel': 'Votre lien de parrainage (cliquez pour copier)',
  'bonus.copy': 'Copier dans le presse-papiers',
  'bonus.copied': 'Copié',
  'bonus.copyFailed': 'Échec de la copie',
  'bonus.refCodeIntro': 'Vous pouvez aussi partager votre code unique, que vos filleuls peuvent utiliser comme code promo.',
  'bonus.transactions': 'Transactions du compte bonus',
  'bonus.referralTree': 'Arbre de parrainage',

  // ── BonusTransactionsPage ──
  'bonusTx.loading': 'Chargement...',
  'bonusTx.back': 'Retour',
  'bonusTx.balance': 'Compte bonus :',
  'bonusTx.date': 'Date',
  'bonusTx.addedBonus': 'Bonus ajouté',
  'bonusTx.usedBonus': 'Bonus utilisé',
  'bonusTx.type': 'Type',
  'bonusTx.empty': 'Aucune transaction sur votre compte bonus pour le moment.',
  'bonusTx.typeM': 'Bonus d\'un achat parrainé',
  'bonusTx.typeC': 'Bonus d\'un achat sous-parrainé',
  'bonusTx.typeO': 'Bonus utilisé pour payer votre commande',
  'bonusTx.typeOOrder': 'Bonus utilisé pour payer votre commande n° {orderId}',
  'bonusTx.typeP': 'Cadeau',
  'bonusTx.typeW': 'Retrait',

  // ── ReferralPage ──
  'referral.back': 'Retour',
  'referral.loading': 'Chargement...',
  'referral.empty': 'Aucune donnée de parrainage disponible.',
  'referral.description': 'Cette section affiche l\'arbre de parrainage à partir de vous. Elle montre aussi les statistiques de bonus d\'un parrainage donné et de sa branche. Notre système multi-niveaux vous permet de gagner 10 % des bonus de parrainage des filleuls de vos parrainages directs.',
  'referral.referral': 'Parrainage',
  'referral.bonuses': 'Bonus de parrainage',
  'referral.subBonuses': 'Bonus de sous-parrainage',
  'referral.level': 'niveau :',
  'referral.bonusesNote': 'Bonus de parrainage — bonus des achats de vos filleuls directs.',
  'referral.subBonusesNote': 'Bonus de sous-parrainage — bonus des filleuls de vos filleuls.',
};
